import create from 'zustand';
import {persist} from 'zustand/middleware';
import appConfig from '../config/app';
import client, { adminClient } from 'helper/httpClient';

export const useAuthStore = create(
    persist(
        (set, get) => ({
            token: null,
            expiredAt: null,
            user: null,
            last2faDate: null,
            setToken: (value) => set(() => ({token: value})),
            setExpiredat: (value) => set(() => ({expiredAt: value})),
            setUser: (value) => set(() => ({user: value})),
            logout: () => {
                set(() => ({token: null, expiredAt: null, user: null, last2faDate: null}));
                delete client.onSending;
                delete adminClient.onSending;
            },
            setLast2faDate: (value) => set(() => ({last2faDate: value}))
        }),
        {name: `${appConfig.storePrefix}-authStore`},
    ),
);
